import _ from 'lodash';

/* Create Unique ID */

export const createUniqueID = (() => {
	let uid = 0;
	return () => {
		return 'X' + (++uid).toString() + +new Date();
	};
})();

/* PubSub */

export const pubsub = (() => {
	const events = {};

	const subscribe = (name, callback) => {
		if (!events[name]) {
			events[name] = [];
		}

		const index = events[name].push(callback) - 1;

		return {
			remove: () => {
				delete events[name][index];
			}
		};
	};

	const publish = (name, data) => {
		if (!events[name]) {
			return;
		}

		events[name].forEach(event => {
			if (typeof event === 'function') {
				event(data || {});
			}
		});
	};

	return {
		subscribe,
		publish
	};
})();

/* DOM */
export const dom = (() => {
	const prefix = (el, propery, value) => {
		const prefixes = ['-webkit-', '-moz-', '-ms-', '-o-', ''];
		prefixes.forEach(prefix => {
			el.style[prefix + propery] = value;
		});
	};

	const onTransitionEnd = (el, callback) => {
		const crossBrowserEvents = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd'];
		crossBrowserEvents.forEach(transitionEndEvent => {
			el.addEventListener(transitionEndEvent, callback, { once: true });
		});
	};

	const onTransitionEndAlways = (el, callback) => {
		const crossBrowserEvents = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd'];
		crossBrowserEvents.forEach(transitionEndEvent => {
			el.addEventListener(transitionEndEvent, callback);
		});
	};

	const onAnimationEnd = (el, callback) => {
		const crossBrowserEvents = ['animationend', 'webkitAnimationEnd', 'oAnimationEnd', 'oanimationend', 'MSAnimationEnd'];
		crossBrowserEvents.forEach(transitionEndEvent => {
			el.addEventListener(transitionEndEvent, callback, { once: true });
		});
	};

	const onAnimationEndAlways = (el, callback) => {
		const crossBrowserEvents = ['animationend', 'webkitAnimationEnd', 'oAnimationEnd', 'oanimationend', 'MSAnimationEnd'];
		crossBrowserEvents.forEach(transitionEndEvent => {
			el.addEventListener(transitionEndEvent, callback);
		});
	};

	return {
		prefix,
		onTransitionEnd,
		onTransitionEndAlways,
		onAnimationEnd,
		onAnimationEndAlways
	};
})();

/* COOKIE */
export const cookie = (() => {
	const get = (name = '') => {
		return _getAll()[name] || null;
	};

	function set(name, value, days) {
		const expires = days ? _createExpiresString(days) : '';
		document.cookie = `${name}=${value}${expires}; path=/`;
	}

	function _createExpiresString(days) {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		return `; expires=${date.toGMTString()}`;
	}

	const _getAll = () => {
		return document.cookie
			.split(';') // Separate into individual cookies
			.map(cookie => cookie.trim()) // Remove surrounding whitespace
			.map(cookie => cookie.split('=')) // Split cookie into key value pairs where [0] = key and [1] = value
			.reduce((prev, cookiePair) => ({ ...prev, [cookiePair[0]]: cookiePair[1] }), {}); // Convert to real key value object
	};

	return {
		get,
		set
	};
})();

// Ratio
export const ratio = (() => {
	function getRatio(ratio, el) {
		const width = el && typeof el !== 'undefined' ? el.offsetWidth : window.innerWidth;
		return Math.floor(width / ratio);
	}

	return {
		getRatio
	};
})();

// GTM
export const GTM = (() => {
	const create = (name, fields) => {
		return {
			'event': name,
			...fields
		}
	}

	const push = (event) => {
		if (_.has(event, 'event')) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(event);
		}
	}

	return {
		create,
		push
	}
})();

export default {
	pubsub,
	dom,
	cookie,
	ratio,
	GTM
};
